import InplayerPaywall from './index';

if (typeof global.window.define === 'function' && global.window.define.amd) {
  global.window.define('inplayerPaywall', function() {
    return InplayerPaywall;
  });
} else if (global.window) {
  global.window.InplayerPaywall = InplayerPaywall;
}



// WEBPACK FOOTER //
// ./src/browser.js